import { render, staticRenderFns } from "./TheLaboratorio.vue?vue&type=template&id=23f2dbb7&"
import script from "./TheLaboratorio.vue?vue&type=script&lang=js&"
export * from "./TheLaboratorio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports